import React, { useCallback } from 'react';
import { Button, ButtonProps } from '@material-ui/core';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import { useTranslate } from 'hooks/use-translate';
import { useAppDispatch } from 'store';
import { patientWhatsAppMessagesActions } from 'store/patient-whats-app-messages';
import { APP_FORMAT_DATE, APP_FORMAT_TIME } from 'configs/const';
import { dateFormat } from 'utils/dates';

interface Props extends ButtonProps {
  userPatientProfileID: string;
  toPhoneNumber: string | undefined | null;
  patient: Pick<Components.Schemas.UserPatientProfile, 'firstName' | 'lastName'>;
  meeting: {
    meetingFromDateTime: string;
    meetingToDateTime: string;
  } | null;
  onDone?: () => void;
}

export const ButtonSendWhatsApp: React.FC<Props> = ({
  userPatientProfileID,
  toPhoneNumber,
  onDone,
  patient,
  meeting,
  ...rest
}) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslate();
  const onClick = useCallback(() => {
    const fromDate = meeting?.meetingFromDateTime;
    const toDate = meeting?.meetingToDateTime;

    const templatePayload = {
      meetingFromDate: fromDate ? dateFormat(fromDate, APP_FORMAT_DATE) : '',
      meetingFromTime: fromDate ? dateFormat(fromDate, APP_FORMAT_TIME) : '',

      meetingToDate: toDate ? dateFormat(toDate, APP_FORMAT_DATE) : '',
      meetingToTime: toDate ? dateFormat(toDate, APP_FORMAT_TIME) : '',

      patient,
    };

    dispatch(
      patientWhatsAppMessagesActions.add({
        uid: `patient-card__${userPatientProfileID}`,
        formData: { userPatientProfileID, toPhoneNumber },
        templatePayload,
        onSuccess: onDone,
      }),
    );
  }, [dispatch, userPatientProfileID, toPhoneNumber, patient, onDone, meeting]);

  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={<WhatsAppIcon />}
      {...rest}
      onClick={onClick}
      disabled={!toPhoneNumber || rest.disabled}
    >
      {t('send-whats-app')}
    </Button>
  );
};
